export default {
    localCheckInterval: 10 * 1000,
    timeToWaitAfterJoin: 15 * 1000,
};
